<!--旅游业绩查询-->
<template>
  <div class="TravelPerformanceInquiry">
    <app-breadcrumb />
    <div class="page-container">
<!--      <p v-if="companyCode !== 'NG'">-->
<!--        Note: Promotion performance cannot be counted repeatedly. If the downline is qualified, the qualified performance of the entire downline network must be deducted from the upline performance.-->
<!--        It is not calculated in the data displayed here, please deduct it by yourself.-->
<!--      </p>-->
<!--      <p v-if="companyCode == 'NG'">-->
<!--        Five star director and above are not eligible for this promotion.-->
<!--      </p>-->
      <el-form label-width="130px">
        <el-form-item v-if="isAgent" :label="$t('miMember.memberNo')">
          <el-input style="width: 300px;margin-right: 10px"  size="mini" v-model.trim="listQuery.memberNo" clearable :placeholder="$t('')"/>
          <el-button   :loading="btnLoading"  size="mini" type="primary" icon="el-icon-search"
                     @click="getList">{{ $t('function.menu.search') }}
          </el-button>
        </el-form-item>
        <el-form-item v-if="this.target">
          <el-progress :percentage="target"></el-progress>
          <p style="text-align: right;color: red;font-weight: 600;line-height: 0">{{targetnum}}</p>
        </el-form-item>
      </el-form>
      <el-table
          v-loading="tableLoading"
          :data="list"
          border
          fit
          size="mini"
          stripe
          style="width: 100%"
      >
        <el-table-column :label="$t('pdWarehouseStock.companyNo')" prop="companyCode" align="center"/>
        <!-- 经销商编号 -->
        <el-table-column :label="$t('miMember.memberNo')" prop="memberNo" align="center"/>
        <!-- 荣衔 -->
        <el-table-column :label="$t('mi.honourLevel')" prop="levelType" align="center">
          <template v-slot="{row}">
            {{$lt(initDict.mimemberhonourLevel,row.cardType)}}
          </template>
        </el-table-column>
        <el-table-column :label="$t('Region.number')" prop="bigPartNo" align="center"/>
<!--        <el-table-column v-if="this.companyCode ==='CM'" :label="$t('The.first.month.1')" prop="smallPartSell1" align="center"/>-->
<!--        <el-table-column v-if="this.companyCode ==='CM'" :label="$t('The.first.month.2')" prop="status1" align="center">-->
<!--          <template v-slot="{row}">-->
<!--            <span v-if="row.status1 == '-'">-</span>-->
<!--            <span v-else-if="row.status1 == '1' ">{{ $t('success.achieved') }}</span>-->
<!--            <span v-else>{{ $t('un.unacommpolished') }}</span>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column :label="$t('The.first.month.3')" prop="bigPartSell" align="center"/>
        <el-table-column :label="$t('The.first.month.4')" prop="smallPartSell" align="center"/>
        <el-table-column v-if="this.companyCode !=='NG'" :label="$t('The.first.month.5')" prop="status" align="center">
          <template v-slot="{row}">
            <span v-if="row.status == '-'">-</span>
            <span v-else-if="row.status == '1' ">{{ $t('success.achieved') }}</span>
            <span v-else>{{ $t('un.unacommpolished') }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('fiBankbookTemp.lastUpdateTime')" prop="createTime" align="center"/>
      </el-table>
      <pagination
          v-show="total>0"
          :total="total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.limit"
          @pagination="getList"
      />
    </div>
  </div>
</template>

<script>
import {chinaTravel} from "@/api/ay-personal-center/travelperformanceinquiry";
import {mapGetters} from "vuex";
import Pagination from "@/components/Pagination.vue";
export default {
  name: 'TravelPerformanceInquiry',
  components: {Pagination},
  data() {
    return {
      memberNoList: [
        { memberNo: 'G01091205005' },
        { memberNo: 'NGN22140305004' },
        { memberNo: 'G09100831001' },
        { memberNo: 'G20120531004' },
        { memberNo: 'NGN27140305002' },
        { memberNo: 'G01100222006' },
        { memberNo: 'G01100222007' },
      ],
      linkNo:'',
      btnLoading: false,
      tableLoading: false,
      loading: false,
      listdata: [],
      list: [],
      total: 0,
      target:0,
      targetnum:0,
      wWeekList: [],
      listQuery: {
        page: 1,
        limit: 10,
        memberNo:''
      },
      initDict: {
        status: 'fi_ac_appl_status_cn',
        mimemberhonourLevel: 'cn.mimember.cardtype',    //荣衔
        mimemberlevel: 'cn.member.level'    //级别
      }
    }
  },
  created() {
    if(!this.isAgent){
      this.getList()
    }
  },
  computed: {
    ...mapGetters([
      'companyCode',
      'isAgent'
    ]),
  },
  methods: {
    getList() {
      this.btnLoading = true
      this.tableLoading = true
      chinaTravel({...this.listQuery}).then(res => {
        console.log(res)
        for (let i = 0; i < res.data.records.length; i++) {
          for (let j = 0; j < this.memberNoList.length; j++) {
            if (res.data.records[i].memberNo === this.memberNoList[j].memberNo) {
              res.data.records[i].cardType = '-'
              res.data.records[i].smallPartSell = '-'
              res.data.records[i].status = '-'
              res.data.records[i].bigPartSell = '-'
              res.data.records[i].smallPartSell = '-'
              res.data.records[i].status = '-'
            }
          }
        }
        this.list = res.data.records
        this.btnLoading = false
        this.tableLoading = false
        // this.getTarget()
      }).catch(() => {
        this.target = 0
        this.targetnum = 0
        this.listQuery = {}
        this.btnLoading = false
        this.tableLoading = false
      })
    },
    getTarget(){
      if(this.companyCode ==='CM'){
        if(this.listQuery.cardType < 4){
          this.targetnum = 15000
          this.target = this.listQuery.smallPartSell2 / 15000 * 100
        }else if(this.listQuery.cardType < 7){
          this.targetnum = 30000
          this.target = this.listQuery.smallPartSell2 / 30000 * 100
        }else if(this.listQuery.cardType >=7){
          this.targetnum = 35000
          this.target = this.listQuery.smallPartSell2 / 35000 * 100
        }
      }
      if(this.companyCode ==='NG'){
        if(this.listQuery.cardType < 4){
          this.targetnum = 15000
          this.target = this.listQuery.smallPartSell2 / 15000 * 100
        }else if(this.listQuery.cardType < 7){
          this.targetnum = 35000
          this.target = this.listQuery.smallPartSell2 / 35000 * 100
        }else if(this.listQuery.cardType >=7){
          this.target = 100
        }
      }
    }
  }
}
</script>

<style>

</style>
